/* @ngInject */
function CampaignActionChecklistItemController ($scope, $rootScope) {
  const api = {}

  this.getApi = () => api

  $scope.unselectChecklist = () => {
    $rootScope.$emit('campaign.attach-checklist-actions', null)
  }
}

export { CampaignActionChecklistItemController }
